export enum HotlistDeclineReason {
  Salary = "Salary",
  Location = "Location",
  LackingRemoteWork = "LackingRemoteWork",
  NoProductInterest = "NoProductInterest",
  MismatchingRequirements = "MismatchingRequirements",
  BadCompanyReputation = "BadCompanyReputation",
  NoCareerOpportunities = "NoCareerOpportunities",
  NoCultureFit = "NoCultureFit",
  Other = "Other",
}